/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Pxk_Scenting_Notes_TitleInputs */

const vi_sl_pxk_scenting_notes_title = /** @type {(inputs: Sl_Pxk_Scenting_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu nhập kho lấy hương từ phiếu này`)
};

/**

* @param {Sl_Pxk_Scenting_Notes_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_pxk_scenting_notes_title = /** @type {((inputs?: Sl_Pxk_Scenting_Notes_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Pxk_Scenting_Notes_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_pxk_scenting_notes_title(inputs)
});